import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { history } from '../../../_helpers';
import { companyActions } from '../../../_actions';
import { SubmitButton } from '../../../_components';

import { GenericNavbarComponent, GenericFooterComponent } from '../../../_components';

import './Company.signup.scss';

class CompanyCreationContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      company_name: "",
      submitted: false,
      empty: false
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if ( sessionStorage.getItem('cellit_userdata') ) return history.push('/');

    document.title = 'Signup - Cellit.io';
  }

  handleChange(e) {
    let val = e.target.value;
    let name = e.target.name;
  
    this.setState({[name]: val});
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({submitted: true});

    const { company_name } = this.state;
    const { dispatch } = this.props;

    const obj = {
      "company": {
        "name": company_name
      }
    }

    if ( company_name ) {
      this.setState({empty: false});

      return dispatch(companyActions.companyCreation(obj))
        .then(res => {
          if ( res.type !== 'COMPANY_CREATION_FAILURE' ) return;

          toast.error(res.error.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-error'
          });

          this.setState({submitted: false});
        })
    }

    this.setState({empty: true, submitted: false})
  }

  render() {
    const { company_name, submitted, empty } = this.state;

    return (
      <div className="register">
        <GenericNavbarComponent />

        <div className="container">
          <div className="row">
            <div className="col">
              <div className="col">
                <h1 className="title text-center">Create your workspace <span role="img" aria-label="company" aria-labelledby="company">🏢</span></h1>
                <p className="subtitle text-center">You can provide your company name or alias</p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 offset-3">
              <form id="register-form" method="POST" className="form" onSubmit={this.handleSubmit}>
                <div className="content-group">
                  <div className="form-step">
                    <div className="form-group">
                      <input
                        type="text"
                        name="company_name"
                        id="company_name"
                        className={empty && !company_name ? 'form-control form-control-error' : 'form-control'}
                        autoComplete="off"
                        onChange={this.handleChange}
                        defaultValue={this.state.company_name}
                      />
                      <label htmlFor="company_name">Company name/alias</label>
                      {empty && !company_name && <div className="input-error">Provide a company name</div>}
                    </div>
                  </div>
                </div>

                <Link to='/signin' className="btn btn-white-outlined">Go back</Link>
                <SubmitButton
                  type="button"
                  color="blue"
                  submitted={submitted}
                  text="Next"
                  altText="Creating company..."
                  event={this.handleSubmit}
                />
              </form>
            </div>
          </div>
        </div>

        <GenericFooterComponent classes="footer footer-registering"/>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { companyCreation } = state.companyCreationReducer;
  return companyCreation;
}

const ConnectedCompanyCreation = connect(mapStateToProps)(CompanyCreationContainer);
export { ConnectedCompanyCreation as CompanyCreationContainer }